/* Calcolatore traversine: barre di confronto e cifre animate. Separato da tl-landing.js (usa data-tl-calc2). */
(function () {
  'use strict';
  if (window.__tlCalc) return;
  window.__tlCalc = true;

  function formatMoney(cents, format) {
    var fmt = format || '€{{amount_with_comma_separator}}';
    var value = (cents / 100);
    function sep(n, dec, thou, dp) {
      var parts = n.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + dec + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return sep(value, '.', ',', 2);
        case 'amount_no_decimals': return sep(value, '.', ',', 0);
        case 'amount_with_comma_separator': return sep(value, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return sep(value, ',', '.', 0);
        case 'amount_with_apostrophe_separator': return sep(value, '.', "'", 2);
        default: return sep(value, ',', '.', 2);
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* Calcolatore: prezzo monouso per confezione da 100 (tl-pack), compatibile col vecchio tl-unit.
     Barre di confronto + cifre che scorrono; l'animazione parte quando il calcolatore entra nello schermo. */
  function initCalc(el) {
    var perDay = el.querySelector('[name="tl-per-day"]');
    var unit = el.querySelector('[name="tl-unit"]');
    var pack = el.querySelector('[name="tl-pack"]');
    var pads = el.querySelector('[name="tl-pads"]');
    var fmt = el.dataset.moneyFormat;
    var basePrice = parseInt(el.dataset.padPrice, 10) || 0;
    var barY = el.querySelector('[data-bar="yearly"]');
    var barW = el.querySelector('[data-bar="washable"]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var keys = ['yearly', 'washable', 'diff'];
    var target = { yearly: 0, washable: 0, diff: 0 };
    var shown = null;
    var raf = 0;
    var visible = !barY || !('IntersectionObserver' in window);
    function out(name, val) { var o = el.querySelector('[data-out="' + name + '"]'); if (o) o.textContent = val; }
    function fm(c) { return formatMoney(Math.round(c), fmt); }
    function paint(v) { keys.forEach(function (k) { out(k, fm(v[k])); }); }
    function announce() { out('sr', 'Monouso in un anno ' + fm(target.yearly) + ', lavabili ' + fm(target.washable) + ', differenza nel primo anno ' + fm(target.diff) + '.'); }
    function bars() {
      if (!barY || !barW || !visible) return;
      var max = Math.max(target.yearly, target.washable, 1);
      barY.style.width = (target.yearly / max * 100) + '%';
      barW.style.width = (target.washable / max * 100) + '%';
    }
    function go() {
      if (raf) cancelAnimationFrame(raf);
      bars();
      if (!visible) { paint({ yearly: 0, washable: 0, diff: 0 }); return; }
      if (reduce || !shown || !window.requestAnimationFrame) {
        shown = { yearly: target.yearly, washable: target.washable, diff: target.diff };
        paint(shown); announce(); return;
      }
      var from = { yearly: shown.yearly, washable: shown.washable, diff: shown.diff };
      var t0 = null, dur = 700;
      function step(now) {
        if (t0 === null) t0 = now;
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        keys.forEach(function (key) { shown[key] = from[key] + (target[key] - from[key]) * e; });
        paint(shown);
        if (k < 1) raf = requestAnimationFrame(step); else { raf = 0; announce(); }
      }
      raf = requestAnimationFrame(step);
    }
    function calc() {
      var d = parseFloat(perDay.value), p = parseInt(pads.value, 10);
      var u = pack ? parseFloat(pack.value) / 100 : parseFloat(unit.value);
      var yearly = Math.round(d * u * 365 * 100);
      var washable = basePrice * p;
      out('per-day', d); out('unit', formatMoney(Math.round(u * 100), fmt)); out('pads', p);
      if (pack) out('pack', formatMoney(Math.round(parseFloat(pack.value) * 100), fmt));
      target = { yearly: yearly, washable: washable, diff: Math.max(0, yearly - washable) };
      go();
    }
    [perDay, unit, pack, pads].forEach(function (i) { if (i) i.addEventListener('input', calc); });
    document.addEventListener('tl:variant', function (e) { basePrice = e.detail.variant.price; calc(); });
    if (!visible) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect(); visible = true;
          shown = { yearly: 0, washable: 0, diff: 0 };
          go();
        });
      }, { threshold: 0.35 });
      io.observe(el);
    }
    calc();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-tl-calc2]:not([data-tl-ready])').forEach(function (el) { el.dataset.tlReady = '1'; initCalc(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
